import React from 'react';
import classnames from 'classnames';
import { string, func,  } from 'prop-types';
import rangeRight from 'lodash/rangeRight';

import Dropdown from 'elements/Inputs/Dropdown';
import Icon from 'foundations/Icons/Icon';
import styles from './ViewsPerPageFilter.css';

const ViewsPerPage = ({ label, min, max, onChange }) => (
  <div className={classnames(styles.viewsPerPageWrapper, 'flex flex-align-center')}>
    <label className="p">{label}</label>
    <Dropdown
      customClasses={styles.dropdown}
      opts={rangeRight(min, max + 1)}
      simplified
      autoWidth
      withoutIcon
      noEmptyState
      onChange={onChange}
    />
    <Icon type="other" icon="chevron-down-13" />
  </div>
);

const max = 10;
const min = 1;

ViewsPerPage.propTypes = {
  label: string.isRequired,

  max: (props, propName) => {
    if(props[propName] < min  || props[propName] > max) {
      return new Error(`Invalid '${propName}' prop (> ${min} && <= ${max})`);
    }
  },

  min: (props, propName) => {
    if(props[propName] < min  || props[propName] > max) {
      return new Error(`Invalid '${propName}' prop (>= ${min} && < ${max})`);
    }
  },

  onChange: func,
};

ViewsPerPage.defaultProps = {
  max: max,
  min: min,
};

ViewsPerPage.displayName = 'ViewsPerPage';

export default ViewsPerPage;



// WEBPACK FOOTER //
// ./src/uis/elements/Pagination/ViewsPerPageFilter/ViewsPerPageFilter.js